/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BellSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABj0lEQVR4nM2Vv0oDQRDGzz8YtLHQNGnEVxALu7SH3M5OhMlMFB/ASlBEFPTsjCAWPoGdtZ15CIs01goKaqmIlUTmYiKRvcueIeAHW9yy+/u+nZvbC4L/osjW0Fh+BuQng2xT10W1WbDSAOQTbziAlMDKC6C0dCRGICUnHLmZrLPS6J86iqYA+RRQ3jvwrgnKq0HZc8KRm/qcCUdcnwErN7/BPSaW9/8EVxnk6z7wo0HgdmhwlUG+Ghpc1W7HIcFVxvJnXjggbwa+cqSPdT4kKrrgaq5zXnAimsyXXOLOWt3bjz8Cli9yJN/tDSOXcRyPptKNle0cNT90dxpvZdX+fjC4tMDyXbqB5Y9+cGP5IPsjlLdUg6hSXRgEDu3155lvOaMsOxmpbw3yGYAs/gmuAhDQrkkG8gZUqmumUl0iounAR1lwY2heWzUMw0IyiIrLK6tzga/S+rxrgPzoKM2DF5yIxn5+LO6LC1Dqjrof+6UPw4KmUZO0W5GIJtRET/J9mrrOeRl0TMrl8rj3hhz6Av+o2I+OZGFVAAAAAElFTkSuQmCC)
 */
export const BellSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1.3 21.3a1 1 0 1 0 1.4 1.4l20-20a1 1 0 0 0-1.4-1.4l-20 20ZM3.13 16.13c.11.27.46.28.66.08L15.73 4.27a.47.47 0 0 0-.07-.74 6.97 6.97 0 0 0-1.35-.64.62.62 0 0 1-.38-.43 2 2 0 0 0-3.86 0 .62.62 0 0 1-.38.43A7 7 0 0 0 5 9.5v2.09a.5.5 0 0 1-.13.33l-1.1 1.22A3 3 0 0 0 3 15.15v.28c0 .24.04.48.13.7ZM18.64 9.36c.13-.13.36-.05.36.14v2.09c0 .12.05.24.13.33l1.1 1.22a3 3 0 0 1 .77 2.01v.28c0 .67-.34 1.29-.95 1.56-1.31.6-4 1.51-8.05 1.51-.46 0-.9-.01-1.33-.03a.48.48 0 0 1-.3-.83l8.27-8.28ZM9.18 19.84A.16.16 0 0 0 9 20a3 3 0 1 0 6 0c0-.1-.09-.17-.18-.16a24.84 24.84 0 0 1-5.64 0Z"
        className={colorClass}
      />
    </svg>
  );
};
